import * as z from "zod";

export const importInternationalCustomsCsv = {
  name: "importInternationalCustomsCsv" as const,
  input: z.object({}),
  output: z.object({
    workflowId: z.string().optional(),
    rowCount: z.number().int().nonnegative(),
    parseErrors: z.array(z.string()),
  }),
};
